export default __webpack_public_path__ + "static/media/reset password.2b648ee2.png";